(($, Drupal) => {
  Drupal.behaviors.kafAutoPrint = {
    attach: context => {
      var $body = $('body', context);
      if (!$body.hasClass('page-node-type-recipe') || window.location.search != '?action=print') {
        return;
      }
      $(function () {
        const iframe = document.getElementById('print-recipe--container');
        if (iframe) {
          iframe.style.display = 'block';
          iframe.setAttribute('aria-hidden', 'false');
        }
      });
    },
  };
})(jQuery, Drupal);
